(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["dsre-asp-dealer-ui-spa"] = factory();
	else
		root["dsre-asp-dealer-ui-spa"] = factory();
})(self, () => {
return 